import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ChallengeProvider } from "@/context/ChallengeContext";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ChallengeHistory from "@/pages/ChallengeHistory";
import Goals from "@/pages/Goals";
import Stats from "@/pages/Stats";
import Journal from "@/pages/Journal";
import CalculatorPage from "@/pages/CalculatorPage";
import Milestones from "@/pages/Milestones";
import Rules from "@/pages/Rules";
import Disclaimer from "@/pages/Disclaimer";
import BrokerMT5 from "@/pages/BrokerMT5";
import Terminal from "@/pages/Terminal";
import SettingsPage from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="demon-bg min-h-screen flex items-center justify-center text-demon-muted font-mono">
        Ładowanie...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <ChallengeProvider>
      <Layout>{children}</Layout>
    </ChallengeProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/challenge" element={<Protected><ChallengeHistory /></Protected>} />
      <Route path="/goals" element={<Protected><Goals /></Protected>} />
      <Route path="/stats" element={<Protected><Stats /></Protected>} />
      <Route path="/journal" element={<Protected><Journal /></Protected>} />
      <Route path="/calculator" element={<Protected><CalculatorPage /></Protected>} />
      <Route path="/broker" element={<Protected><BrokerMT5 /></Protected>} />
      <Route path="/terminal" element={<Protected><Terminal /></Protected>} />
      <Route path="/settings" element={<Protected><SettingsPage /></Protected>} />
      <Route path="/milestones" element={<Protected><Milestones /></Protected>} />
      <Route path="/rules" element={<Protected><Rules /></Protected>} />
      <Route path="/disclaimer" element={<Protected><Disclaimer /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(12,10,18,0.92)",
              border: "1px solid rgba(168,85,247,0.3)",
              color: "#e2e8f0",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}
